import numeral from 'numeral'

export const numberWithCommas = (input: number): string => {
    return numeral(input).format('0,0')
}

export const numberAsCurrency = (input: number, precision: number = 3): string => {
    return numeral(input).format(`0,0.${new Array(precision).fill('0').join('')}`)
}

export const numberWithPercent = (input: number, precision: number = 2): string => {
    let format = !Number.isFinite(precision) ? '0.00%' : `0.${new Array(precision).fill('0').join('')}%`
    return numeral(input).format(format)
}

export const numberWithSuffix = (input: number): string => {
    return numeral(input).format('0o')
}
